module.exports = __webpack_public_path__ + "img/empty.9b8db798.png";